import { memo } from 'react';
import { CommonLoginTemplate } from 'components/templates/CommonLoginTemplate';

type Props = {};

export const CommonLoginPage = memo((_props: Props) => {
	return <CommonLoginTemplate />;
});
